module.exports = __webpack_public_path__ + "img/dial4.591d1bc2.png";